<div class="subBlockContainer" id="azureSubscription">
  <div class="combination-loader" style="display: flex;">
    <!-- sidenav -->
    <div class="child-sidebar" style="border-right: 1px solid #dee2e6;">
      <child-header [title]="'Manage Azure Subscription'" (closeEvent)="close()"></child-header>
      <!-- filter -->
      <div class="searchInputGroup">
        <div class="searchIcon search-carts">
          <img src="../images/new_ui/filter.png">
        </div>
        <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
          onblur="this.placeholder='Filter'" [formControl]="menuFilterControl">
      </div>
      <!-- menu -->
      <ng-container *ngFor="let m of (sideMenu | TableFilter: 'displayName' : menuFilterControl?.value);let i = index">
        <div *ngIf="!m.disabled" class="menu-wrapper menu-wrapper-position" [class.active]="isActive(i)"
          (click)="changeSection(i)">
          <div class="total-div" style="display: flex;">
            <div class="narrow-title">{{ m?.displayName }}</div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- body -->
    <div class="child-body" *ngIf="showContent">
      <child-header [title]="azurePlan?.out_stk_description" (closeEvent)="closeBody()"></child-header>
      <form class="content" [formGroup]="upgradeSubscriptionForm">

        <!-- Subscription Details -->
        <div [ngClass]="{hide: currentMenuIndex !==  sideMenu[0]?.tabIndex}">
          <ng-container>    
           <div style="display: flex;">
              <h6>SUBSCRIPTION DETAILS</h6>
            </div>        
            <br/>
            <div class="row">
              <div class="col-sm">
                <label>STOCK CODE:</label>
                <span class="red-bold"> {{from.out_stock_code}}</span>
              </div>
              <div class="col-sm">
                <label style="margin-left: -100px;">OFFER DESCRIPTION :</label>
                <span class="red-bold"> {{from.out_stk_description}}</span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm">
                <label>MPN:</label>
                <span class="red-bold" style="margin-left:45px;">  {{from.out_mpnid =='' ? NoMPNText : from.out_mpnid}}</span>
                <i style="margin: -10px 0 0 10px; vertical-align: middle;" class="basic-icon edit-icon cursor-pointer"
                (click)="toggleMPNChange()"></i>
              </div>
              <div class="col-sm">
                <label style="margin-left: -98px;">DESC :</label>
                <span class="red-bold" style="margin-left:85px;">  {{from.out_sub_description}}</span>
                <i class="basic-icon edit-icon cursor-pointer" style="margin: -10px 0 0 10px; vertical-align: middle;"
                (click)="toggleDescChange()"></i>
              </div>
            </div>

            <div class="my-2">
              <div class="col-6">
                <mat-form-field *ngIf="editMpn" class="full-width my-4" appearance="fill" style="padding-left: 0px;">
                  <input type="text" placeholder="Change MPN" aria-label="Number" matInput integerOnly
                    #trigger="matAutocompleteTrigger" formControlName="mpn" [matAutocomplete]="auto">
                  <i *ngIf="upgradeSubscriptionForm.get('mpn').enabled" class="material-icons align-arrow-right"
                    (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option [value]="NoMPNText">
                      {{NoMPNText}}
                    </mat-option>
                    <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                      {{mpn}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <mat-spinner *ngIf="upgradeSubscriptionForm.get('mpn').disabled" mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading" style="position: relative;top:35px" diameter="20">
              </mat-spinner>
            </div>

            <!--  <div class="my-2">
              DESC :
              <span class="red-bold">
                {{from.out_sub_description}}
              </span>
              <i class="basic-icon edit-icon cursor-pointer"  style="margin: -10px 0 0 10px; vertical-align: middle;" (click)="toggleDescChange()"></i>
            </div> -->

            <div class="my-2">
              <div class="col-6">
                <mat-form-field *ngIf="editDesc" class="full-width my-4" appearance="fill" style="padding-left: 0px;">
                  <input type="text" placeholder="Change Description" aria-label="Number" matInput
                    #trigger="matAutocompleteTrigger" formControlName="desc" [matAutocomplete]="auto">
                  <i *ngIf="upgradeSubscriptionForm.get('desc').enabled" class="material-icons align-arrow-right"
                    (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                  <mat-autocomplete #auto="matAutocomplete">
                    <!-- <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                      {{mpn}}
                    </mat-option> -->
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <mat-spinner *ngIf="upgradeSubscriptionForm.get('desc').disabled" mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading" style="position: relative;top:35px" diameter="20">
              </mat-spinner>
            </div>
            <br />
            <br />
            <div style="display: flex;">
              <h6>SUBSCRIPTION MANAGEMENT</h6>
            </div>

            <div class="my-2">
              <p>
                Due to increased security measures imposed by GDAP, some subscriptions may not be visible in the
                Azure Management Portal without additional permissions being granted. Global Administrators are able to 
                update these permissions and gain access to the subscription by following the procedure
                outlined in the Microsoft document linked below. 
              </p>
              <p><b>Elevate access as a global admin -</b>

                <a class="link"
                  href="https://learn.microsoft.com/en-us/azure/role-based-access-control/elevate-access-global-admin?tabs=azure-portal"
                  target="_blank">
                  https://learn.microsoft.com/en-us/azure/role-based-access-control/elevate-access-global-admin?tabs=azure-portal
                </a>
              </p>
            </div>
            <br />
            <div>
              <button class="azureManagementPortalButton" style="margin-left: 450px;">
                <img src="../images/new_ui/Azurelogo.png">
                <!-- <a href="https://portal.azure.com/#@{{this.domainName}}/resource/subscriptions/{{this.subscriptionId}}" -->
                <a href="https://portal.azure.com/#@{{this.domainName}}"             
                  target="_blank" style="text-decoration:none"> Azure Management portal</a>
              </button>
            </div>
            <br />
            <br />
            <div style="display: flex;">
              <h6>SUBSCRIPTIONS</h6>
              <app-refresh-button *ngIf="subscriptionTableDataSrc" style="margin-left: auto;"
                [spinnerRotate]="refreshing" (refreshCallBack)="refresh()"></app-refresh-button>
            </div>          
            <div>
            <div class="searchInputGroup push-left" style="margin-left: 5px;">
              <div *ngIf="subscriptionTableDataSrc?.length">
                <div class="searchIcon" *ngIf="subscriptionTableDataSrc?.length">
                  <img src="../../images/new_ui/filter.png">
                </div>
                <input class="searchInput" type="text" name="filterex" placeholder="Filter" onfocus="this.placeholder=''"
                  onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="filterAzureSubscriptions()"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div style="margin-left: 1095px;
                          margin-top: -40px;">
              <button 
                class="button button-red button-round"
                [disabled]="!currentUser?.hasAdminAccess && !currentUser?.hasPurchaseAccess"
                [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"	
                matTooltip="Requires Purchasing Permissions"
                (click)="createSubscription()"
              >
                &nbsp;Create&nbsp;
              </button>
            </div>
            </div>

            <div class="my-4">
              <ng-container>
                <mat-spinner *ngIf="loading" mode="indeterminate" class="circle" diameter="20"
                  style="display: block; margin-left: auto; margin-right: auto;">
                </mat-spinner>
              </ng-container>


              <table mat-table [dataSource]="tableDataSrc" *ngIf="subscriptionTableDataSrc?.length && !loading">
                <div class="row">
                  <div class="col-8">
                    <ng-container matColumnDef="friendlyName">
                      <th mat-header-cell *matHeaderCellDef width="5%">Name</th>
                      <td mat-cell *matCellDef="let element">{{ element.friendlyName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="entitlementId">
                      <th mat-header-cell *matHeaderCellDef width="8%">Entitlement Id</th>
                      <td mat-cell *matCellDef="let element"><a class="link"
                          href="https://portal.azure.com/#@{{ element.tenantDomain }}/resource/subscriptions/{{ element.entitlementId }}/overview"
                          target="_blank"> {{ element.entitlementId }} </a></td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef width="5%">Status</th>
                      <td mat-cell *matCellDef="let element">{{ element.status }}</td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                  </div>
                </div>
              </table>

              <label class="noData-wrapper" *ngIf="!subscriptionTableDataSrc?.length && !loading">
                No result for this subscription
              </label>
            </div>


            <div class="my-2" style="display: flex;justify-content: center;">
              <button class="button button-red button-large" *ngIf="currentUser?.hasPurchaseAccess"
                [disabled]="((upgradeSubscriptionForm.get('mpn').value == from.out_mpnid) && (upgradeSubscriptionForm.get('desc').value == from.out_sub_description))"
                (click)="updateSubscriptionDetails()">SAVE DETAILS</button>

              <button *ngIf="isCancelable && currentUser?.hasPurchaseAccess" class="button button-red button-large"
                (click)="cancelSubscription(from)" [disabled]="isCanceling">Cancel Subscription</button>
              <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                style="position: relative;top:15px" *ngIf="isCanceling">
              </mat-spinner>
            </div>
          </ng-container>
        </div>

        <!-- Manage Service -->
        <div [ngClass]="{hide: currentMenuIndex !==  sideMenu[1]?.tabIndex}">
          <ng-container>
            <div style="display: flex;">
              <h6>MANAGE SERVICE</h6>
            </div>

            <div class="my-2">
              <span>This will suspend service, you will continue to accrue charges as per this subscriptions existing
                commitment. Additional commitments will also accrue if auto-renew is still enabled</span>
            </div>

            <div class="my-4">
              <div style="display: inline-flex;">
                <span class="highlight-text">SERVICE STATUS : </span>
                <span> {{this.from.out_status_desc}} </span>
                <mat-slide-toggle 
                  style="margin-top: -4px;"
                  [disableControl]="
                    !isRenewLoaded ||
                    !currentUser?.hasPurchaseAccess ||
                    this.from.out_status_desc == 'Pending Creation' ||
                    (!currentUser?.hasAdminAccess && !currentUser?.hasPurchaseAccess)
                  "
                  [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"	
                  matTooltip="Requires Purchasing Permissions"
                  formControlName="activeSuspend" (change)="toggleSuspendHandler()" class="activesuspend mx-4">
                </mat-slide-toggle>
                <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                  class="circle cSPCustomerEntitlements-loading" diameter="20" *ngIf="!isRenewLoaded">
                </mat-spinner>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Fraud Notifications -->
        <div [ngClass]="{hide: currentMenuIndex !==  sideMenu[2]?.tabIndex}">
          <div style="display: flex;">
            <h6>FRAUD NOTIFICATIONS</h6>
            <app-refresh-button *ngIf="fraudsLazyLoaded" style="margin-left: auto;"
              [spinnerRotate]="sideMenu[2]?.refreshingFlag" (refreshCallBack)="refreshFraudNotifications()">
            </app-refresh-button>
          </div>

          <div class="my-4">
            <ng-container>
              <mat-spinner *ngIf="sideMenu[2].refreshingFlag" mode="indeterminate" class="circle" diameter="20"
                style="display: block; margin-left: auto; margin-right: auto;">
              </mat-spinner>
            </ng-container>
            <table mat-table matSort [dataSource]="dataSource" (matSortChange)="matSortData($event)" matSortDisableClear
              *ngIf="showFraudTable && fraudNotificationTableDataSrc?.length">
              <div class="row">
                <div class="col-8">

                  <ng-container matColumnDef="entityName">
                    <th mat-header-cell *matHeaderCellDef width="13%" mat-sort-header="entityName">Entity Name</th>
                    <td mat-cell *matCellDef="let element">
                      <span>{{ element.entityName }}</span>
                    </td>
                  </ng-container>

                 <!--  <ng-container matColumnDef="hitCount">
                    <th mat-header-cell *matHeaderCellDef width="5%" mat-sort-header="hitCount">Hit Count</th>
                    <td mat-cell *matCellDef="let element">{{ element.hitCount }}</td>
                  </ng-container> -->

                  <ng-container matColumnDef="serviceName">
                    <th mat-header-cell *matHeaderCellDef width="8%" mat-sort-header="serviceName">Service Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.serviceName }}</td>
                  </ng-container>

                  <ng-container matColumnDef="resourceName">
                    <th mat-header-cell *matHeaderCellDef width="8%" mat-sort-header="resourceName">ResourceName</th>
                    <td mat-cell *matCellDef="let element">{{ element.resourceName }}</td>
                  </ng-container>

                  <ng-container matColumnDef="resourceGroupName">
                    <th mat-header-cell *matHeaderCellDef width="17%" mat-sort-header="resourceGroupName">Resource Group Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.resourceGroupName }}</td>
                  </ng-container>

                  <ng-container matColumnDef="lastOccurrence">
                    <th mat-header-cell *matHeaderCellDef width="10%" mat-sort-header="lastOccurrence">Last Occurrence</th>
                    <td mat-cell *matCellDef="let element">{{ element.lastOccurrence | date:'dd-MM-yyyy h:mm a' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="actionsOne">
                    <th mat-header-cell *matHeaderCellDef width="8%"></th>
                    <td mat-cell *matCellDef="let element">
                      <button class="button button-red button-round"
                        (click)="onFraudTableActionButtonEvent(element?.eventId, 'Fraud')">
                        Fraud
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actionsTwo">
                    <th mat-header-cell *matHeaderCellDef width="5%"></th>
                    <td mat-cell *matCellDef="let element">
                      <button class="button button-red button-round"
                        (click)="onFraudTableActionButtonEvent(element?.eventId, 'Ignore')">
                        Ignore
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </div>
              </div>
            </table>

            <label class="noData-wrapper"
              *ngIf="!fraudNotificationTableDataSrc?.length && !sideMenu[2]?.refreshingFlag">
              No fraud notifications found for this subscription
            </label>
          </div>

        </div>

        <!-- Budgets & Alerts -->
        <div [ngClass]="{hide: currentMenuIndex !==  sideMenu[3]?.tabIndex}">
          <app-budget-and-alerts *ngIf="budgetsLazyLoaded" [subscriptionId]="subscriptionId" [tenantId]="tenantId">
          </app-budget-and-alerts>
        </div>

        <!-- Subscriptions -->
        <!--   <div *ngIf="!sideMenu[4]?.disabled" [ngClass]="{hide: currentMenuIndex !== sideMenu[4]?.tabIndex}">
          <app-mas-subscriptions *ngIf="subscriptionsLazyLoaded" [subscriptionId]="subscriptionId"
            [tenantId]="tenantId"></app-mas-subscriptions>
        </div> -->

      </form>
    </div>
  </div>
</div>
<router-outlet></router-outlet>